"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _assign = _interopRequireDefault(require("../_helpers/assign"));

function PseudoMap() {} // PseudoMap simulates WeakMap behavior with O(1) search complexity
// it's needed to support @IE9 and @IE10


(0, _assign["default"])(PseudoMap.prototype, {
  get: function get(obj) {
    return obj.seempleData;
  },
  set: function set(obj, data) {
    Object.defineProperty(obj, 'seempleData', {
      value: data,
      enumerable: false,
      writable: false,
      configurable: false
    });
  },
  has: function has(obj) {
    return 'seempleData' in obj;
  }
});

var _default = typeof WeakMap === 'undefined' ? new PseudoMap() : new WeakMap();

exports["default"] = _default;
//# sourceMappingURL=defs.js.map